var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$store.state.webNavigator == "pc"
      ? _c("div", { staticClass: "homeTeam" }, [
          _c("div", { staticClass: "home-team marginAuto" }, [
            _vm._m(0),
            _c(
              "div",
              {
                staticClass: "swiper-container banner3 home-team-bar home-rol"
              },
              [
                _c(
                  "div",
                  { staticClass: "swiper-wrapper" },
                  _vm._l(_vm.rolllist2, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "swiper-slide" },
                      [
                        _c("img", {
                          staticClass: "home-team-img",
                          attrs: {
                            src: item,
                            alt: "3大团队·脂玫乐健康瘦身更专业",
                            title: ""
                          }
                        })
                      ]
                    )
                  }),
                  0
                ),
                _c("div", { staticClass: "swiper-button-prev" }),
                _c("div", { staticClass: "swiper-button-next" })
              ]
            )
          ])
        ])
      : _c("div", { staticClass: "phone-page" }, [
          _c("div", { staticClass: "home-team" }, [
            _vm._m(1),
            _c(
              "div",
              { staticClass: "swiper-container bannerTeam home-team-bar" },
              [
                _c(
                  "div",
                  { staticClass: "swiper-wrapper" },
                  _vm._l(_vm.rolllist2Phone, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "swiper-slide" },
                      [
                        _c("img", {
                          staticClass: "home-team-img",
                          attrs: {
                            src: _vm.httptype(item),
                            alt: "3大团队·脂玫乐健康瘦身更专业",
                            title: ""
                          }
                        })
                      ]
                    )
                  }),
                  0
                ),
                _c("div", {
                  staticClass: "swiper-pagination",
                  attrs: { id: "phoneTeam-pagination" }
                })
              ]
            )
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "p",
        {
          staticClass: "part-title list-tlt displayIB",
          staticStyle: { width: "100%" }
        },
        [
          _vm._v("3大团队·脂玫乐健康瘦身更专业"),
          _c("span", { staticClass: "list-tlt-tip" }, [_vm._v("-")])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "PhoneHome-title" }, [
      _vm._v("3大团队 "),
      _c("span", { staticClass: "col00CDA2" }, [_vm._v("-")]),
      _c("br"),
      _vm._v("脂玫乐健康瘦身更专业")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fd184e3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fd184e3","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/hometest/comPonents/homeTeam/homeTeam.vue
// module id = 967
// module chunks = 1